import { 
        UPDATE_CURRENT_INPUT,
        ALTER_DISABLED_STATUS_OF_INPUTBOX } from '../actions/actionTypes'

import objectPath from 'object-path'
import {AlmeState, defaultState} from "../../../../wireup/AlmeState";
import {AnyAction} from "redux";
export default function reduce(state = defaultState, action: AnyAction): AlmeState
{
    switch(action.type)
    {
        case UPDATE_CURRENT_INPUT:
            let inputLocation = action.payload.currentInputLoc;
            let newInput = action.payload.input;

            let curInputState = Object.assign({}, state);
            objectPath.set(curInputState, inputLocation, newInput);

            return curInputState;

        case ALTER_DISABLED_STATUS_OF_INPUTBOX:
            let stateLocation = action.payload.stateLocation;
            let existingState = Object.assign({}, state);
            objectPath.set(existingState, stateLocation, action.payload.inputboxDisabled);
            return existingState;

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/window-inputbox/src/reducers/index.ts